import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import "../userDashboard.css";
import GetStartedVideosWrapperComp from "../../../components/sharedcomponents/GetStartedVideosWrapperComp";

export const UserGettingStartedPage = () => {
  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar
          showBackButton
          displayType="title"
          title="Getting Started"
          showNotification
        ></TopBar>
        <GetStartedVideosWrapperComp></GetStartedVideosWrapperComp>
        <Tabbar menuType={"users"}></Tabbar>
      </div>
    </>
  );
};

export default UserGettingStartedPage;
